import React from 'react';
import { Col, Row } from 'reactstrap';
import LoginForm from '../LoginForm';

const Login = () => (
  <>
    <Row className="text-left justify-content-between">
      <Col xs="auto" />
    </Row>
    <LoginForm />
  </>
);

export default Login;
